export const APP_VERSION = {
  version: '0.0.13',
  buildDate: '2026-03-20T07:46:37.705Z',
  commitHash: 'N/A'
};
